// extracted by mini-css-extract-plugin
export default {"Wrapper":"AgencyReassignment_Wrapper__-pmLu","Title":"AgencyReassignment_Title__BSLwd","Grid":"AgencyReassignment_Grid__Jdbn5","Selector":"AgencyReassignment_Selector__0z5St"};